import { useRef as l } from "react";
import { getTextValue as i } from '../utils/get-text-value.js';
import { useEvent as o } from './use-event.js';
function b(c) {
  var t = l(""),
    r = l("");
  return o(function () {
    var e = c.current;
    if (!e) return "";
    var u = e.innerText;
    if (t.current === u) return r.current;
    var n = i(e).trim().toLowerCase();
    return t.current = u, r.current = n, n;
  });
}
export { b as useTextValue };